import type { HtmlDesignTarget } from './htmlDesignSlice';

import type { RootState } from 'js/src/libs/RootState';

export const getCodeoEditModeSceneId = (state: RootState): string | null =>
    state.htmlDesign?.activeConversationTarget?.sceneId ?? null;

export const getHtmlDesignTarget = (
    state: RootState,
    conversationId: string | undefined,
): HtmlDesignTarget | null =>
    (conversationId ? state.htmlDesign?.targetByConversation[conversationId] : undefined) ?? null;
